import clsx from "clsx";
import { type HTMLMotionProps, motion } from "framer-motion";

interface ButtonProps extends HTMLMotionProps<"button"> {
	size?: `xs` | `sm` | `md` | `lg` | `xl`;
	variant?: `filled` | `outlined` | `coach` | null;
}

const Button = ({
	children,
	size = `md`,
	variant = `filled`,
	className,
	...props
}: ButtonProps) => {
	const variants = {
		filled: `bg-sky-500 dark:bg-sky-600 border-2 border-sky-500 enabled:hover:border-sky-600 enabled:hover:dark:border-sky-700 dark:border-sky-600  text-white enabled:hover:bg-sky-600 enabled:hover:dark:bg-sky-700 focus:ring-sky-200 focus:dark:ring-slate-700 shadow shadow-black/10 dark:shadow-slate-950`,
		outlined: `bg-transparent  border-2 border-sky-500 hover:bg-slate-600/10 hover:dark:bg-slate-700 focus:ring-sky-200 focus:dark:ring-slate-700 shadow shadow-black/10 dark:shadow-slate-950 `,
		coach: `bg-purple-400 border-2 border-purple-400 enabled:hover:border-purple-500 dark:bg-purple-500 dark:border-purple-500 enabled:hover:dark:border-purple-600 enabled:hover:dark:bg-purple-600 text-white enabled:hover:bg-purple-500 focus:ring-purple-400/50 focus:dark:ring-slate-700 shadow shadow-black/10 dark:shadow-slate-950`,
	};

	const sizes = {
		xs: `px-2.5 py-1.5 text-xs`,
		sm: `px-3 py-2 text-sm`,
		md: `px-4 py-2 text-base`,
		lg: `px-4 py-2.5 text-[1rem]`,
		xl: `px-6 py-3 text-xl`,
	};

	return (
		<motion.button
			{...props}
			className={clsx(
				`inline-flex h-auto select-none items-center justify-center rounded-[10px] font-medium transition-shadow duration-200 focus-visible:ring-4 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none`,
				variant && variants[variant],
				sizes[size],
				className,
			)}
		>
			{children}
		</motion.button>
	);
};

export default Button;
